import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lib-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogComponent {
  /** Заголовок модального окна */
  @Input()
  public header: string;
  /** Флаг отображения модального окна */
  @Input()
  public visible: boolean;
  /** Ширина отображения модального окна */
  @Input()
  public width: string;
  /** Класс */
  @Input()
  public styleClass: string;
  /** Наименования кнопки закрытия */
  @Input()
  public closeButtonLabel = 'ОК';
  @Input()
  public hasAcceptButton = false;
  @Input()
  public acceptButtonLabel = '';

  /** Событие изменения флага */
  @Output()
  public visibleChange = new EventEmitter<boolean>();
  /** Событие закрытия модального окна */
  @Output()
  public hideDialog = new EventEmitter<boolean>();
  /** Событие открытия модального окна */
  @Output()
  public showDialog = new EventEmitter();
  @Output()
  public accept = new EventEmitter();

  /**
   * Обработчик закрытия окна.
   * @param event событие.
   */
  public onClose(event: boolean): void {
    this.visible = !event;
    this.hideDialog.emit(event);
    this.visibleChange.emit(this.visible);
  }

  public onAccept(): void {
    this.visible = false;
    this.accept.emit();
    this.visibleChange.emit(this.visible);
  }
}
